import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StrainReportModel} from "@app/strain/common/models/strain-report.model";
import {StrainReportType} from "@app/strain/common/models/enum/strain-report-type.enum";

@Component({
    selector: 'app-strain-report-card',
    templateUrl: './strain-report-card.component.html',
    styleUrls: ['./strain-report-card.component.scss']
})
export class StrainReportCardComponent implements OnInit {
    @Input() reportFile: StrainReportModel;
    @Input() canDelete: boolean;

    @Output() download = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    doSelect(type: StrainReportType) {
        this.download.emit({report: this.reportFile, reportType: type})
    }

    doRemove() {
        this.delete.emit(this.reportFile);
    }

    public get reportType(): typeof StrainReportType {
        return StrainReportType;
    }

    hasType(type: StrainReportType) {
        return this.reportFile.availableTypes.some(item => item === type);
    }
}
